import { render } from "./App.vue?vue&type=template&id=e0ef3e48&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e0ef3e48&lang=css"
import "./App.vue?vue&type=style&index=1&id=e0ef3e48&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ef3e48"]])

export default __exports__